module.exports = __webpack_public_path__ + "img/weizhan.60c04db2.jpg";